import { KreditlinieVhvKautionEntry } from './kreditlinie-vhv-kaution-entry.model';

export class ProduktlinieVhvKautionEntry {

    produktlinieName: string;
    nextProduktlinien: { produktlinie: string }[];
    kreditlinien: KreditlinieVhvKautionEntry[] = [];

    public doDeserialize(input: any): ProduktlinieVhvKautionEntry {
        this.produktlinieName = input['produktlinieName'];
        this.nextProduktlinien = input['nextProduktlinien'] ?? [];

        this.kreditlinien = [];
        if (input['kreditlinien']) {
            for (const entry of input['kreditlinien']) {
                const k = new KreditlinieVhvKautionEntry();
                k.buergschaftsLinie = entry['buergschaftsLinie'];
                k.einzellimit = entry['einzellimit'];
                k.hoechstBetragPercent = entry['hoechstBetragPercent'];
                k.jahresBeitrag = entry['jahresBeitrag'];
                this.kreditlinien.push(k);
            }
        }

        return this;
    }

    getEntry(buergschaftsLinie: string): KreditlinieVhvKautionEntry {
        console.debug(buergschaftsLinie);

        for (const entry of this.kreditlinien) {
            if (entry.buergschaftsLinie === +buergschaftsLinie) {
                return entry;
            }
        }

        return null;
    }

    getCurrentProduktlinie(): string {
        return this.produktlinieName;
    }

    getNextProduktlinien(): string[] {
        const result = [this.getCurrentProduktlinie()];

        if (this.nextProduktlinien) {
            const nextProduktlinien = this.nextProduktlinien.map(entry => entry.produktlinie);
            result.push(...nextProduktlinien);
        }

        return result;
    }

}
